import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from 'features/userSlice';
import TermsAndServicesPortuguese from './pt';
import TermsAndServicesSpanish from './es';
import TermsAndServicesEnglish from './en';

function TermsAndServices() {
  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const defaultLanguage = searchParams.get('language');

  useEffect(() => {
    if (defaultLanguage) {
      if (defaultLanguage === 'pt-br' || defaultLanguage === 'en-us' || defaultLanguage === 'es-es') {
        dispatch(setLanguage(defaultLanguage));
        navigate('/public/terms-and-service');
      }
    }
  }, []);

  if (user.language === 'pt-br') {
    return <TermsAndServicesPortuguese />;
  }

  if (user.language === 'es-es') {
    return <TermsAndServicesSpanish />;
  }

  return <TermsAndServicesEnglish />;
}

export default TermsAndServices;
